<template>
  <div class="auoutus">
    <div class="t_header" v-if="w_width<888">
      <div class="fx_cs t_topbar">
        <img src="../assets/img/homepage/logotop.png" style="height: 28px" />
        <i class="iconfont iconzu1714" style="color: #FFFFFF" @click="change()"></i>
      </div>
      <div class="t_s_title">
        <img src="../assets/img/1661.jpg" style="width: 100%">
        <div class="t_s_txt">
          <span class="ausp1" style="font-size: 32px;padding: 0">关于我们</span>
          <span class="ausp2" style="font-size: 30px">ABOUT US</span>
        </div>
      </div>
    </div>
    <div class="header" v-else>
      <div class="topbar"> 
        <img src="../assets/img/homepage/logotop.png" />
        <myheader></myheader>
      </div>
      <div class="widtol mesdiv1">
        <div class="audiv1">
          <span class="ausp1">关于我们</span>
          <span class="ausp2">ABOUT US</span>
        </div>
      </div>
    </div>
    <div style="display: flex;position: relative;" v-if="w_width<888">
      <img src="../assets/img/1662.jpg" style="width: 100%">
      <div class="t_a_msp4">
        南通易阳科技有限公司成立于2005年4月，目前公司位于国家级科技园区南通崇川科技园 
        <div style="margin-top: 15px">
          15年的积淀，30人的核心团队，70%以上研发人员，专注为企业用户提供信息化管理解决方案
        </div>
      </div>
    </div>
    <div class="mesdiv4" v-else>
      <div class="widtol mesdiv5">
        <span class="messp3">关于易阳科技</span>
        <span class="messp4">
          南通易阳科技有限公司成立于2005年4月，目前公司位于国家级科技园区南通崇川科技园 <br>
          15年的积淀，30人的核心团队，70%以上研发人员，专注为企业用户提供信息化管理解决方案
          </span>
        <img class="ausimg" src="../assets/img/23.png">
      </div>
    </div>

    <div class="t_bcgray" style="padding: 37px 0;background: #FFF" v-if="w_width<888">
      <div class="t_s_txt3">企业资质</div>
      <div style="text-align: center;margin-top: 30px">
        <img src="../assets/img/1172.jpg" style="width: 94%">
        <div style="font-size: 15px;color:#717B81;margin-top: 20px">
          高新技术企业证书
        </div>
      </div>
      <div style="text-align: center;margin-top: 30px">
        <img src="../assets/img/1165.jpg" style="width: 94%">
        <div style="font-size: 15px;color:#717B81;margin-top: 20px">
          CMMI3
        </div>
      </div>
    </div>

    <div class="t_bcgray" style="padding: 37px 0 10px 0" v-if="w_width<888">
      <div class="t_s_txt3">软件著作权</div>
      <div class="t_txt8" style="margin: 15px 0 25px 0">累积获得软件著作权20多项</div>
      <div class="swiper-container">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(auth,index) in auths" :key="index">
            <img :src="auth.img" style="width: 100%">
            <div class="authdiv5" style="font-size: 15px;padding: 20px 0 40px 0">
              {{auth.name}}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bcgray" v-else>
      <div class="widtol authdiv1">
        <span class="authsp1">企业资质</span>
        <div class="authdiv2" style="user-select:none;">
          <div class="authdiv3">
            <div class="authdiv6">
              <div class="authdiv4" style="width: 332px;height: 234px">
                <img src="../assets/img/1165.jpg">
              </div>
              <div class="authdiv5">CMMI3</div>
            </div>
            <div class="authdiv6">
              <div class="authdiv4" style="width: 332px;height: 234px">
                <img src="../assets/img/1171.jpg">
              </div>
              <div class="authdiv5">软件企业认定证书</div>
            </div>
            <div class="authdiv6" style="margin:0">
              <div class="authdiv4" style="width: 332px;height: 234px">
                <img src="../assets/img/1172.jpg">
              </div>
              <div class="authdiv5">高新技术企业证书</div>
            </div>
          </div>
        </div>
      </div>
      <div class="widtol authdiv1">
        <span class="authsp1">软件著作权</span>
        <span class="authsp2">累积获得软件著作权20多项</span>
        <div class="authdiv2" style="user-select:none;">
          <div class="leftbtn" @click="toleft">
            <img class="leftauicon" src="../assets/img/32.png" >
            <img class="leftauiconhover" src="../assets/img/33.png" >
          </div>
          <div class="rightbtn" @click="toright">
            <img class="rightauicon" src="../assets/img/35.png" >
            <img class="rightauiconhover" src="../assets/img/34.png" >
          </div>
          <div class="authdiv3">
            <div class="authdiv6"  v-for="(auth,index) in auths" :key="index">
              <div class="authdiv4">
                <img :src="auth.img">
              </div>
              <div class="authdiv5">
                {{auth.name}}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div style="padding: 35px 0;background: #FFF" v-if="w_width<888">
      <div class="t_s_txt3">项目业绩</div>
      <div style="width: 100%;margin: 35px 0 15px 0">
        <div class="t_a_tear" :class="currentYear == index?'t_a_chose':'t_a_unchose'" v-for="(item,index) in years" :key="index" @click="selectYear(index)">
          {{item.year}}
        </div>
        <div class="timeline2" style="padding: 0">
          <ul v-if="currentYear == 0" style="width: 80%;margin: 0 10%">
            <li style="margin: 100px 0">
              <div :style="{width:productH+'px'}">
                <span class="t_projectsp1">2020年1月</span>
                <span class="t_projectsp2">临品商城</span>
                <span class="t_projectsp3">
                  临品汇平台，包括仓储物流、经销加盟、会员管理、区域配送等子系统
                </span>
              </div>
            </li>
          </ul>
          <ul v-if="currentYear == 1" style="width: 80%;margin: 0 10%">
            <li style="margin: 100px 0 140px 0">
              <div :style="{width:productH+'px'}">
                <span class="t_projectsp1">2019年1月</span>
                <span class="t_projectsp2">东隆集团生产管理系统</span>
                <span class="t_projectsp3">
                  东隆（上海）集团旗下4个工厂（羽绒、面料、成衣）的生产管理、物料流转、成本核算等
                </span>
              </div>
            </li>
            <li style="margin: 140px 0">
              <div :style="{width:productH+'px'}">
                <span class="t_projectsp1">2019年2月</span>
                <span class="t_projectsp2">印宝云盒</span>
                <span class="t_projectsp3">
                  远程打印，手机打印，替代传统打印服务器，办公、学校远程资料打印（开放API）
                </span>
              </div>
            </li>
            <li style="margin: 140px 0">
              <div :style="{width:productH+'px'}">
                <span class="t_projectsp1">2019年4月</span>
                <span class="t_projectsp2">TM产线管理系统</span>
                <span class="t_projectsp3">
                  王子造纸（南通）TM产线流程管理、生产设备实时信息交互、计划跟踪、产成品仓储物流管理等功能
                </span>
              </div>
            </li>
            <li style="margin: 140px 0 100px 0">
              <div :style="{width:productH+'px'}">
                <span class="t_projectsp1">2019年8月</span>
                <span class="t_projectsp2">营销支撑数据分析系统</span>
                <span class="t_projectsp3">
                  东丽（南通）产品管理、展会管理、样衣样品库，热度分析等营销数据支撑系统
                </span>
              </div>
            </li>
          </ul>
          <ul v-if="currentYear == 2" style="width: 80%;margin: 0 10%">
            <li style="margin: 100px 0 140px 0">
              <div :style="{width:productH+'px'}">
                <span class="t_projectsp1">2018年2月</span>
                <span class="t_projectsp2">加工跟单</span>
                <span class="t_projectsp3">
                  自有产品，通过跟单APP完成现场数据、物流数据的采集录入，通过云终端插件完成产品标签打印
                </span>
              </div>
            </li>
            <li style="margin: 140px 0">
              <div :style="{width:productH+'px'}">
                <span class="t_projectsp1">2018年4月</span>
                <span class="t_projectsp2">自动配料系统</span>
                <span class="t_projectsp3">
                  根据工艺条件，计算加工对象所需配料用量，自动称重、搅拌，通过输送管道至加工机台。（与配料控制单元对接）
                </span>
              </div>
            </li>
            <li style="margin: 140px 0">
              <div :style="{width:productH+'px'}">
                <span class="t_projectsp1">2018年6月</span>
                <span class="t_projectsp2">智能仓储（WCS、WMS）</span>
                <span class="t_projectsp3">
                  子母梭车控制（WCS），结合上位仓库管理系统（WMS），实现智能仓库，动态优化存储区域调度，提升仓储作业效率，同时在现场大屏、PDA上3D实时展示仓库货物分布
                </span>
              </div>
            </li>
            <li style="margin: 140px 0 100px 0">
              <div :style="{width:productH+'px'}">
                <span class="t_projectsp1">2018年9月</span>
                <span class="t_projectsp2">委外加工管理系统</span>
                <span class="t_projectsp3">
                  东丽（南通）委外加工管理，通过企业微信平台完成品质、物流跟踪，采用云打印技术远程打印面料二维码标签
                </span>
              </div>
            </li>
          </ul>
          <ul v-if="currentYear == 3" style="width: 80%;margin: 0 10%">
            <li style="margin: 100px 0 140px 0">
              <div :style="{width:productH+'px'}">
                <span class="t_projectsp1">2017年4月</span>
                <span class="t_projectsp2">乳品下单配送系统</span>
                <span class="t_projectsp3">
                  （日本）协同乳业，为医院、学校定制的牛奶下单配送系统开发。采用PDA掌机实现对塑料托盘超高频RFID标签的读写交互
                </span>
              </div>
            </li>
            <li style="margin: 140px 0">
              <div :style="{width:productH+'px'}">
                <span class="t_projectsp1">2017年8月</span>
                <span class="t_projectsp2">NTA现场计划、成本管理系统</span>
                <span class="t_projectsp3">
                  帝人（南通）汽车内饰面料加工厂现场加工信息采集、按工序工艺设置加工计划、计算加工成本现场采用WinCE工业终端完成数据采集
                </span>
              </div>
            </li>
            <li style="margin: 140px 0">
              <div :style="{width:productH+'px'}">
                <span class="t_projectsp1">2017年10月</span>
                <span class="t_projectsp2">3PL物流配送系统</span>
                <span class="t_projectsp3">
                  王子造纸（南通）成品物流配送、转储跟踪系统使用PDA掌机（安卓）、通过4G网与私有云服务通信
                </span>
              </div>
            </li>
            <li style="margin: 140px 0 100px 0">
              <div :style="{width:productH+'px'}">
                <span class="t_projectsp1">2017年12月</span>
                <span class="t_projectsp2">云POS打印</span>
                <span class="t_projectsp3">
                  为支付宝口碑定制云POS打印机。独有通讯安全保障协议，并行分布式部署，达到口碑交易性能指标要求（≥20万 TPS）
                </span>
              </div>
            </li>
          </ul>
          <ul v-if="currentYear == 4" style="width: 80%;margin: 0 10%">
            <li style="margin: 100px 0">
              <div :style="{width:productH+'px'}">
                <span class="t_projectsp1">2016年9月</span>
                <span class="t_projectsp2">JARTIC交通信息系统</span>
                <span class="t_projectsp3">
                  （日本）冲绳交通、气象、道路保养等信息交互平台，为导航服务开放信息
                </span>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="bcwhite" v-else>
      <div class="widtol projdiv1">
        <span class="authsp1">项目业绩</span>
        <div class="projdiv2">
          <div class="projdiv3">
            <div class="year" :class="currentYear == index?'selectedYear':''" v-for="(item,index) in years" :key="index" @click="selectYear(index)">
              {{item.year}}年
            </div>
          </div>
          <div class="timeline">
            <ul v-if="currentYear == 0">
              <li>
                <div>
                  <span class="projectsp1">2020年1月</span>
                  <span class="projectsp2">临品商城</span>
                  <span class="projectsp3">临品汇平台，包括仓储物流、经销加盟、会员管<br>理、区域配送等子系统</span>
                </div>
              </li>
            </ul>

            <ul v-if="currentYear == 1">
              <li>
                <div>
                  <span class="projectsp1">2019年1月</span>
                  <span class="projectsp2">东隆集团生产管理系统</span>
                  <span class="projectsp3">东隆（上海）集团旗下4个工厂（羽绒、面料、成<br>衣）的生产管理、物料流转、成本核算等</span>
                </div>
              </li>
              <li>
                <div>
                  <span class="projectsp1">2019年2月</span>
                  <span class="projectsp2">印宝云盒</span>
                  <span class="projectsp3">远程打印，手机打印，替代传统打印服务器，办公、<br>学校远程资料打印（开放API）</span>
                </div>
              </li>
              <li>
                <div>
                  <span class="projectsp1">2019年4月</span>
                  <span class="projectsp2">TM产线管理系统</span>
                  <span class="projectsp3">王子造纸（南通）TM产线流程管理、生产设备实时<br>信息交互、计划跟踪、产成品仓储物流管理等功能</span>
                </div>
              </li>
              <li>
                <div>
                  <span class="projectsp1">2019年8月</span>
                  <span class="projectsp2">营销支撑数据分析系统</span>
                  <span class="projectsp3">东丽（南通）产品管理、展会管理、样衣样品库，<br>热度分析等营销数据支撑系统</span>
                </div>
              </li>
            </ul>

            <ul v-if="currentYear == 2">
              <li>
                <div>
                  <span class="projectsp1">2018年2月</span>
                  <span class="projectsp2">加工跟单</span>
                  <span class="projectsp3">自有产品，通过跟单APP完成现场数据、物流数据<br>的采集录入，通过云终端插件完成产品标签打印</span>
                </div>
              </li>
              <li>
                <div>
                  <span class="projectsp1">2018年4月</span>
                  <span class="projectsp2">自动配料系统</span>
                  <span class="projectsp3">根据工艺条件，计算加工对象所需配料用量，自<br>动称重、搅拌，通过输送管道至加工机台。（与<br>配料控制单元对接）</span>
                </div>
              </li>
              <li>
                <div>
                  <span class="projectsp1">2018年6月</span>
                  <span class="projectsp2">智能仓储（WCS、WMS）</span>
                  <span class="projectsp3">子母梭车控制（WCS），结合上位仓库管理系统<br>（WMS），实现智能仓库，动态优化存储区域调<br>度，提升仓储作业效率，同时在现场大屏、PDA<br>上3D实时展示仓库货物分布</span>
                </div>
              </li>
              <li>
                <div>
                  <span class="projectsp1">2018年9月</span>
                  <span class="projectsp2">委外加工管理系统</span>
                  <span class="projectsp3">东丽（南通）委外加工管理，通过企业微信平台完<br>成品质、物流跟踪，采用云打印技术远程打印面料<br>二维码标签</span>
                </div>
              </li>
            </ul>

            <ul v-if="currentYear == 3">
              <li>
                <div>
                  <span class="projectsp1">2017年4月</span>
                  <span class="projectsp2">乳品下单配送系统</span>
                  <span class="projectsp3">（日本）协同乳业，为医院、学校定制的牛奶下<br>单配送系统开发。采用PDA掌机实现对塑料托盘<br>超高频RFID标签的读写交互</span>
                </div>
              </li>
              <li>
                <div>
                  <span class="projectsp1">2017年8月</span>
                  <span class="projectsp2">NTA现场计划、成本管理系统</span>
                  <span class="projectsp3">帝人（南通）汽车内饰面料加工厂现场加工信息<br>采集、按工序工艺设置加工计划、计算加工成本<br>现场采用WinCE工业终端完成数据采集</span>
                </div>
              </li>
              <li>
                <div>
                  <span class="projectsp1">2017年10月</span>
                  <span class="projectsp2">3PL物流配送系统</span>
                  <span class="projectsp3">王子造纸（南通）成品物流配送、转储跟踪系统<br>使用PDA掌机（安卓）、通过4G网与私有云服务<br>通信</span>
                </div>
              </li>
              <li>
                <div>
                  <span class="projectsp1">2017年12月</span>
                  <span class="projectsp2">云POS打印</span>
                  <span class="projectsp3">为支付宝口碑定制云POS打印机。独有通讯安全<br>保障协议，并行分布式部署，达到口碑交易性能<br>指标要求（≥20万 TPS）</span>
                </div>
              </li>
            </ul>

            <ul v-if="currentYear == 4">
              <li>
                <div>
                  <span class="projectsp1">2016年9月</span>
                  <span class="projectsp2">JARTIC交通信息系统</span>
                  <span class="projectsp3">（日本）冲绳交通、气象、道路保养等信息交互<br>平台，为导航服务开放信息</span>
                </div>
              </li>
            </ul>
          </div>


        </div>
      </div>
    </div>

    <div style="position: relative;" v-if="w_width<888">
      <img src="../assets/img/1663.jpg" style="width: 100%">
      <div class="t_a_tel">
        <div class="t_s_txt3">联系我们</div>
        <div class="t_a_info" style="padding: 20px 7%">
          <div class="t_a_list">
            <span style="width: 70px">咨询电话：</span>
            <span>400-152-3152</span>
          </div>
          <div class="t_a_list">
            <span style="width: 70px">服务邮箱：</span>
            <span>Info@nyy.com.cn</span>
          </div>
          <div class="t_a_list">
            <span style="width: 70px">联系地址：</span>
            <span style="width: calc(100% - 70px)">江苏省南通市崇川区华汇智谷科学产业园26-1幢5楼</span>
          </div>
        </div>
        <div style="text-align: center;">
          <span style="font-size: 16px;color:#333333">扫一扫，联系我们</span><br>
          <img src="../assets/img/31.png" style="width:130px;height:130px;margin: 10px 0">
        </div>
      </div>
    </div>
    <div class="addrimg" v-else>
      <div class="ausdiv2">联系我们</div>
      <div class="widtol">
        <div class="ausdiv3">
          <span class="aussp3">咨询电话：400-152-3152 (周一至周五 09:00-18:00)<br>服务邮箱：Info@nyy.com.cn</span>
        </div>
        <div class="ausdiv7">
          <div class="ausdiv4">
            <span>扫一扫，联系我们</span>
            <div style="border-radius:10px;overflow:hidden;margin-top:7px">
              <img src="../assets/img/31.png" style="width:130px;height:130px">
            </div>
          </div>
          <div class="ausdiv5">
            联系地址
            <div class="ausdiv6" style="padding-top:10px">
              <div>
                <i class="iconfont iconlujing2471 icondizhi"></i>
              </div>
              <div style="padding-left:10px">
                <span class="aussp4" style="font-weight:bold">江苏省南通市崇川区<br>华汇智谷科学产业园26-1幢5楼</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div style="position: absolute;top: 0;width: 100%;height: 100%;background: rgba(0,0,0,0.42);" v-show="false">
      <div class="animation" style="width: 100%;position: absolute;top: 0;background: #FFFFFF;padding: 40px 7%;">
        <div style="text-align: right">
          <span style="font-size: 25px">✕</span>
        </div>
        <div class="t_list">首页</div>
        <div class="t_list fx_cs" @click="listShow=true">
          TMIP产品体系
          <i class="iconfont iconlujing3278 t_icon2"></i>
        </div>
        <div class="t_list" @click="goto('/service')">服务与支持</div>
        <div class="t_list" style="border: 0" @click="goto('/aboutus')">关于我们</div>
      </div>
    </div>
    <!---首页弹出----->
    <mt-popup
      v-model="boxShow"
      position="right">
      <div style="display: block;padding: 40px 7%;" :style="{width:w_width+'px',height:w_height+'px'}">
        <div style="text-align: right">
          <span style="font-size: 25px" @click="boxShow=false">✕</span>
        </div>
        <div class="t_list" @click="goto('/#')">首页</div>
        <div class="t_list fx_cs" @click="listShow=true">
          TMIP产品体系
          <i class="iconfont iconlujing3278 t_icon2"></i>
        </div>
        <div v-show="listShow">
          <div class="t_t_list" @click="goto('/mes')">MES 生产管理</div>
          <div class="t_t_list" @click="goto('/wms')">WMS 智慧仓储</div>
          <div class="t_t_list" @click="goto('/mtr')">MTR 物料溯源</div>
          <div class="t_t_list" @click="goto('/emv')">EMV 生产可视化</div>
        </div>
        <div class="t_list" @click="goto('/service')">服务与支持</div>
        <div class="t_list" style="border: 0" @click="boxShow=false">关于我们</div>
      </div>
    </mt-popup>
  </div>
</template>

<script>
import util from "../components/util";
import Swiper from "swiper";
export default util.useCommon({
  data() {
    return {
      currentYear:0,
      auths:[
        {
          img: require('../assets/img/author/1.jpg'),
          name:'NPMS协同办公系统V1.0'
        },
        {
          img: require('../assets/img/author/2.jpg'),
          name:'染化料计量系统V1.0'
        },
        {
          img: require('../assets/img/author/3.jpg'),
          name:'纺织制造信息化管理平台V3.0'
        },
        {
          img: require('../assets/img/author/4.jpg'),
          name:'现场进度采集软件V4.0'
        },
        {
          img: require('../assets/img/author/5.jpg'),
          name:'面料贸易管理系统V2.0'
        },
        {
          img: require('../assets/img/author/6.jpg'),
          name:'羽绒生产管理软件V2.0'
        },
        {
          img: require('../assets/img/author/7.jpg'),
          name:'短信交易平台V1.0'
        },
        {
          img: require('../assets/img/author/8.jpg'),
          name:'微信电商系统V1.0'
        },
        {
          img: require('../assets/img/author/9.jpg'),
          name:'加工跟单软件V1.0'
        },
        {
          img: require('../assets/img/author/10.jpg'),
          name:'羽绒仓库手持终端管理软件V1.0'
        },
        {
          img: require('../assets/img/author/11.jpg'),
          name:'面料质检软件V4.0'
        },
        {
          img: require('../assets/img/author/12.jpg'),
          name:'羽绒现场包装称重软件V2.0'
        },
        {
          img: require('../assets/img/author/13.jpg'),
          name:'职能3D仓库系统V1.0'
        },
      ],
      years:[
        {
          year:'2020'
        },
        {
          year:'2019'
        },
        {
          year:'2018'
        },
        {
          year:'2017'
        },
        {
          year:'2016'
        }
      ],
      w_width:0,
      autoH:0,
      productH:0,
      boxShow: false,
      listShow:true,
      w_height:0,
    };
  },
  watch: {
  },
  methods: {
    toleft(){
      this.auths.unshift(this.auths.pop());
    },
    toright(){
      this.auths.push(this.auths.shift());
    },
    selectYear(idx){
      this.currentYear = idx;
    },
    change(){
      this.boxShow = true;
      console.log(this.boxShow);
    },
    goto(add) {
      this.backtop();
      this.$router.push(add);
    },
    backtop() {
      this.$emit('gotoTop');
    }
  },
  mounted() {
    this.w_width = window.innerWidth;
    console.log(this.w_width);
    this.autoH = 0.68*window.innerWidth/648*874+85;
    this.productH = window.innerWidth*0.8-65;
    this.w_height = window.innerHeight;
    var swiper = new Swiper('.swiper-container', {
      slidesPerView: 'auto',
      centeredSlides: true,
      spaceBetween: 30,
      autoplay: {
        disableOnInteraction: false,
        delay: 2000,
      },
    });
  },
  activated() {
  }
});
</script>
<style scoped>
.timeline{
  padding-top: 60px;
}
.timeline ul{
  padding: 0px;
}
.timeline ul li{
  list-style: none;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background-color: #CFDFFF;
  border: 1px solid #536DFE;
  position: relative;
  margin: 90px auto;
}
.timeline ul li:first-child::before{
  content: '';
  height: 80px;
  width: 1px;
  position: absolute;
  left: 50%;
  top: -80px;
  transform: translateX(-50%);
  background-color: #536DFE;
}
.timeline ul li:last-child::after{
  content: '';
  height: 80px;
  width: 1px;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  background-color: #536DFE;
  top: 15px;
}
.timeline ul li::before{
  content: '';
  height: 46px;
  width: 1px;
  position: absolute;
  left: 50%;
  top: -46px;
  transform: translateX(-50%);
  background-color: #536DFE;
}
.timeline ul li::after{
  content: '';
  height: 45px;
  width: 1px;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  background-color: #536DFE;
  top: 15px;
}
.timeline ul li div{
  position: absolute;
  width: 400px;
  top: 50%;
  transform: translateY(-50%);
  text-align: left;

}
.timeline li:nth-child(odd) div {
    left: 100px;
}
.timeline li:nth-child(odd) div::before {
    content: '';
    width: 64px;
    height: 1px;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    background-color: #DFE4FF;
    left: -80px;
}
.timeline li:nth-child(even) div {
    left: -458px;
}
.timeline li:nth-child(even) div::before{
    content: '';
    width: 64px;
    height: 1px;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    background-color: #DFE4FF;
    right: -50px;
}
.timeline2 ul{
  padding: 0px;
}
.timeline2 ul li{
  list-style: none;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background-color: #CFDFFF;
  border: 1px solid #536DFE;
  position: relative;
  margin: 90px auto;
}
.timeline2 ul li:first-child::before{
  content: '';
  height: 80px;
  width: 1px;
  position: absolute;
  left: 50%;
  top: -80px;
  transform: translateX(-50%);
  background-color: #536DFE;
}
.timeline2 ul li:last-child::after{
  content: '';
  height: 80px;
  width: 1px;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  background-color: #536DFE;
  top: 15px;
}
.timeline2 ul li::before{
  content: '';
  height: 70px;
  width: 1px;
  position: absolute;
  left: 50%;
  top: -71px;
  transform: translateX(-50%);
  background-color: #536DFE;
}
.timeline2 ul li::after{
  content: '';
  height: 70px;
  width: 1px;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  background-color: #536DFE;
  top: 15px;
}
.timeline2 ul li div{
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  text-align: left;

}
.timeline2 li div {
    left: 65px;
}
.timeline2 li div::before {
    content: '';
    width: 34px;
    height: 1px;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    background-color: #DFE4FF;
    left: -45px;
}
</style>
<style lang="less" scoped>
.addrimg{
  width: 100%;
  height: 635px;
  background-image: url('../assets/img/bg/bg.jpg');
  background-repeat: no-repeat;
  background-size: cover;
  -webkit-background-size: cover;
  -o-background-size: cover;
  background-position: center 0;
  padding-top: 75px;
}
.ausdiv2{
  text-align: center;
  font: normal normal normal 46px/56px Microsoft YaHei;
  letter-spacing: 0px;
  color: #333333;
  opacity: 1;
}
.ausdiv3{
  width: 460px;
  height: 104px;
  border-radius: 9px;
  background-color: #303F9F;
  padding: 28px 16px 16px 32px;
  margin-top: 72px;
  margin-bottom: 36px;
}
.aussp3{
  font: normal normal normal 16px/28px Microsoft YaHei;
  letter-spacing: 0px;
  color: #FFFFFF;
  opacity: 1;
}
.ausdiv4{
  display: inline-block;
  font: normal normal normal 16px/32px Microsoft YaHei;
  letter-spacing: 0px;
  color: #212121;
  opacity: 1;
}
.ausdiv5{
  display: inline-block;
  font: normal normal bold 16px/32px Microsoft YaHei;
  letter-spacing: 0px;
  color: #212121;
  opacity: 1;
  padding-left: 30px;
}
.ausdiv7{
  display: flex;
  display: -webkit-flex;
  flex-direction: row;
  flex-wrap: nowrap;
}
.ausdiv6{
  display: flex;
  display: -webkit-flex;
  flex-direction: row;
  flex-wrap: nowrap;
  /* align-items: center; */
  
}
.icondizhi{
  font-size: 28px;
  color: #536DFE;
  position: relative;
  top: 10px;
}

.aussp4{
  font: normal normal normal 16px/23px Microsoft YaHei;
  letter-spacing: 0px;
  color: #707070;
  opacity: 1;
}
.authdiv1{
  padding: 85px 0 110px 0;
  text-align: center;
}
.authsp1{
  font: normal normal normal 46px/56px Microsoft YaHei;
  letter-spacing: 0px;
  color: #333333;
  opacity: 1;
  display: block;
  padding-bottom: 30px;
}
.authsp2{
  font: normal normal normal 20px/32px Microsoft YaHei;
  letter-spacing: 0px;
  color: #717B81;
  opacity: 1;
}
.authdiv2{
  padding-top: 40px;
  position: relative;
}
.authdiv3{
  display: flex;
  display: -webkit-flex;
  flex-direction: row;
  flex-wrap: nowrap;
  overflow: auto;
}

隐藏滚动条
.authdiv3::-webkit-scrollbar {
  display: none; /* Chrome Safari */
}
.authdiv3 {
  scrollbar-width: none; /* firefox */
  -ms-overflow-style: none; /* IE 10+ */
  overflow-x: hidden;
  overflow-y: auto;
}


.authdiv4{
  width: 237px;
  height: 322px;
}
.authdiv4 img{
  width: 100%;
  height: 100%;
}
.authdiv5{
  padding-top: 15px;
  font: normal normal normal 16px/26px Microsoft YaHei;
  letter-spacing: 0px;
  color: #717B81;
  opacity: 1;
  text-align: center;
  word-break: break-all;
}

.authdiv6:not(:last-child){
  margin-right: 46px;
}
.leftbtn, 
.rightbtn{
  width: 53px;
  height: 53px;
  position: absolute;
  border-radius: 50%;
  box-shadow: 0px 3px 6px #00000029;
  top: 174px;
  img{
    width: 100%;
    height: 100%;
  }
}
.leftbtn{
  left: 0px;
}
.leftbtn:hover{
  cursor: pointer;
  .leftauicon{
    display: none;
  }
  .leftauiconhover{
    display: block;
  }
}
.rightbtn:hover{
  cursor: pointer;
  .rightauicon{
    display: none;
  }
  .rightauiconhover{
    display: block;
  }
}
.rightbtn{
  right: 0px;
}
.leftauiconhover,
.rightauiconhover{
  display: none;
}
.projdiv1{
  text-align: center;
  padding: 86px 0 84px;
}
.projdiv2{
  padding: 60px 0;
}
.projdiv3{
  display: flex;
  display: -webkit-flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
}
.year{
  width: 156px;
  height: 47px;
  text-align: center;
  font: normal normal bold 22px/32px Source Han Sans CN;
  color: #333333;
  box-shadow: 0px 0px 6px #3E548229;
  border-radius: 8px;
  line-height: 47px;
  position: relative;
  z-index: 9;
}
.year:hover{
  cursor: pointer;
  // opacity: 0.6;
}
.year:not(:last-child)::before{
  content: '';
  width: 76px;
  height: 1px;
  background-color: #DFE4FF;
  top: 50%;
  right: -76px;
  z-index: 1;
  transform: translateY(-50%);
  position: absolute;
}
.selectedYear{
  background-color: #536DFE!important;
  color: #FFFFFF;
}
</style>
<style scoped>
.projectsp1{
  font: normal normal normal 18px/32px Microsoft YaHei;
  color: #7A8CFF;
}
.projectsp2{
  font: normal normal bold 20px/32px Source Han Sans CN;
  color: #333333;
  display: block;
  margin-bottom: 16px;
}
.projectsp3{ 
  font: normal normal normal 16px/24px Microsoft YaHei;
  color: #717B81;
}
.auoutus{
  background-color: #fbfbfb;
}
.header {
  background-image: url("../assets/img/bg/8.jpg");
  height: 520px;
  position: relative;
}
.mesdiv4 {
  /* background-image: url("../assets/img/bg/2.jpg"); */
  background-color: #4054C8;
  height: 315px;
}
.mesdiv5{
  padding-top: 80px;
  position: relative;
}
.ausimg{
  position: absolute;
  top: 50px;
  right: 0px;
  width: 390px;
  height: 250px;
}
.audiv1{
  width: 230px;
  text-align: center;
  margin: 0 auto;
  padding-top: 90px;
}
.ausp1{
  display: block;
  text-align: center;
  font: normal normal normal 56px/56px HuXiaoBo-NanShen;
  letter-spacing: 0px;
  color: #FFFFFF;
  opacity: 1;
  padding-bottom: 14px;
}
.ausp2{
  font: normal normal bold 40px/56px Microsoft YaHei;
  letter-spacing: 0px;
  color: #536DFE;
  opacity: 1;
}
.animation{
  animation:myTab2 1s;
  -webkit-animation:myTab2 1s; /*Safari and Chrome*/
}
@keyframes myTab2{
  from{top: -500px;}
  to{top: 0px;}
}
.swiper-container {
  width: 100%;
}
.swiper-slide {
  text-align: center;
  width: 60%;
}
</style>
